import { useMemo } from 'react';

import type { CodeString } from '@/consts/codes';
import { menu } from '@/consts/navigation';
import { buildRouteMapping, findMatchingRoute } from '@/features/header/utils/breadcrumbs';
import type { TranslationKey } from '@/i18n/i18n';
import { useLocation } from 'react-router';

interface Breadcrumb {
  label: TranslationKey;
  route?: string;
  code?: CodeString;
  isClickable?: boolean;
}

export const useBreadcrumbs = (): Breadcrumb[] => {
  const location = useLocation();
  const allRoutes = useMemo(() => buildRouteMapping(menu), []);

  return useMemo(() => {
    const active = findMatchingRoute(location.pathname, allRoutes);
    if (!active) return [];

    const breadcrumbs: Breadcrumb[] = [];

    if (active.parentChain && active.parentChain.length > 0) {
      for (const parentLabel of active.parentChain) {
        const parentRoute = allRoutes.find((r) => r.label === parentLabel);
        breadcrumbs.push({
          label: parentLabel,
          route: parentRoute?.route,
          code: parentRoute?.code,
          isClickable: !!(parentRoute?.route && !parentRoute.isRedirectOnly)
        });
      }
    }

    breadcrumbs.push({
      label: active.label,
      route: active.route,
      code: active.code,
      isClickable: false
    });

    return breadcrumbs;
  }, [location.pathname, allRoutes]);
};
